import { waTautan } from "../lib/batasPcs";

// Teks WhatsApp tampilan HP (aturan Haryanto 25/10/2026 butir 4). Nomor SELALU dari Pengaturan (settings.nomor_whatsapp, atau
// nomor_whatsapp yang dikirim server bersama galat batas pcs) → wa.me/<nomor>?text=…; tidak ada nomor yang ditulis di kode.
// "lebih dari 50.000 pcs": angka = batas "Maks pcs per pesanan" dari server (bawaan 50.000).
export const TEKS_WA = {
  ongkirPending: (invoice, tautan) => `Halo Hoonstore, saya ingin konfirmasi ongkir pesanan ${invoice}. Detail: ${tautan}`,
  pesanBesar: (namaProduk, maks) => `Halo Hoonstore, saya ingin pesan ${namaProduk} lebih dari ${Number(maks || 50000).toLocaleString("id-ID")} pcs.`,
  tanyaPesanan: (invoice) => `Halo Hoonstore, saya ingin bertanya tentang pesanan ${invoice}.`,
  sulitMasuk: () => "Halo Hoonstore, saya kesulitan masuk ke akun.",
  umum: () => "Halo Hoonstore, saya ingin bertanya.",
};

export const tautanWa = (nomor, teks) => waTautan(nomor, teks);
